const content = {
  instructions: 'Choose a time slot below and create a dating schedule for your dating activities.',
  note: 'If a day is activated but has no timeslots then your friends can schedule dates with you anytime on those days.'
}

export default content